import { COIN_METADATA_MAP } from "constant/coin"
import { StorageDataMap } from "constant/storage"
import Favicon from "react-favicon"
import { Helmet } from "react-helmet-async"
import { useLocalStorage } from "react-use"

// This component receive string and pass it to the browser title bar, as seen in dydx
interface TitleBarStatsProps {
    marketPriceStr?: string
    title?: string
}

const { DYNAMIC_FAVICON } = StorageDataMap

export function TitleBarStats({ marketPriceStr = "", title = "" }: TitleBarStatsProps) {
    const coinInfo = COIN_METADATA_MAP[title]
    const imgUrl = coinInfo?.IMG_PATH

    const [dynamicFavicon] = useLocalStorage(DYNAMIC_FAVICON.name, DYNAMIC_FAVICON.defaultValue)

    const faviconUrl = dynamicFavicon === "true" && imgUrl ? imgUrl : "/favicon.svg"

    return (
        <>
            <Helmet>
                <title>
                    {marketPriceStr && `$${marketPriceStr} | `} {title && `${title} — `}Perpetual Protocol
                </title>
            </Helmet>
            <Favicon url={faviconUrl} />
        </>
    )
}
